import React from 'react';

export default function AccessGate() {
  return (
    <main style={s.container}>
      <section style={s.card}>
        <h1 style={s.title}>This Link Is Invalid or Has Expired</h1>
        <p style={s.copy}>Please contact your agent for a new invite link.</p>
      </section>
    </main>
  );
}

const s = {
  container: {
    width: '100%',
    maxWidth: 700,
    margin: '0 auto',
    paddingTop: 32,
  },
  card: {
    background: '#fff',
    borderRadius: 12,
    padding: '28px 32px',
    boxShadow: '0 2px 16px rgba(26,51,100,0.10)',
    textAlign: 'center',
  },
  title: {
    color: '#1a3364',
    marginTop: 0,
    marginBottom: 10,
  },
  copy: {
    color: '#4a6288',
    lineHeight: 1.6,
    marginTop: 0,
  },
};
